import React from 'react'
import Testimonials from '../components/Testimonials';

function Testimonial() {
  return (
    <div className=" testimonial mt-5">
      <Testimonials/>

    </div>
  )
}

export default Testimonial;